/**
 * fiurel-cart-prices.js
 * ─────────────────────────────────────────────────────────────────
 * Global cart script for the Fiurel Horizon theme.
 */

(function () {
  "use strict";

  /* ── Inject global CSS to hide addon rows immediately on render ── */
  var style = document.createElement("style");
  style.textContent = '[data-fc-addon="1"] { display: none !important; }';
  document.head.appendChild(style);

  /* ============================================================
     CART DATA HELPERS
  ============================================================ */

  function getCart() {
    return fetch("/cart.js").then(function (r) {
      return r.json();
    });
  }

  function buildAddonMap(cart) {
    var addonByParent = {}; /* parentKey → cents */
    var addonKeys = new Set();
    var addonRowKeys = {}; /* parentKey → [item.key, ...] for deletion */

    cart.items.forEach(function (item) {
      var p = item.properties || {};
      if (p["_fc_addon"] !== "1") return;

      addonKeys.add(item.key);

      // O addon diz-nos quem é o seu "pai" através desta propriedade
      var pk = p["_fc_parent"];
      if (!pk) return;

      if (!addonByParent[pk]) addonByParent[pk] = 0;
      if (!addonRowKeys[pk]) addonRowKeys[pk] = [];

      addonByParent[pk] += item.original_line_price;
      addonRowKeys[pk].push(item.key);
    });

    return {
      addonByParent: addonByParent,
      addonKeys: addonKeys,
      addonRowKeys: addonRowKeys,
    };
  }

  /* ============================================================
     FETCH INTERCEPT
  ============================================================ */
  var _origFetch = window.fetch;

  window.fetch = function (input, init) {
    var url = typeof input === "string" ? input : (input && input.url) || "";
    var req = _origFetch.apply(this, arguments);

    if (!/\/cart\.js(\?|$)/.test(url)) {
      if (/\/cart\/(add|change|update)\.js/.test(url)) {
        req.then(function () {
          scheduleHide(600);
        });
      }
      return req;
    }

    return req.then(function (response) {
      return response
        .clone()
        .json()
        .then(function (cart) {
          var modified = mergeAddonPrices(cart);
          return new Response(JSON.stringify(modified), {
            status: response.status,
            headers: response.headers,
          });
        })
        .catch(function () {
          return req;
        });
    });
  };

  function mergeAddonPrices(cart) {
    var map = buildAddonMap(cart);

    cart.items.forEach(function (item) {
      var p = item.properties || {};
      if (p["_fc_addon"] === "1") return;

      /* ALTERAÇÃO AQUI: Em vez de usar o product_id, usamos a propriedade única gerada no momento da compra */
      var pk = p["_fc_parent"];
      if (!pk) return;

      var extra = map.addonByParent[pk] || 0;
      if (!extra) return;

      item.original_line_price += extra;
      item.final_line_price += extra;

      if (item.quantity > 0) {
        item.original_price += Math.round(extra / item.quantity);
        item.final_price += Math.round(extra / item.quantity);
      }
    });

    cart.items = cart.items.filter(function (item) {
      return !map.addonKeys.has(item.key);
    });

    cart.item_count = cart.items.reduce(function (s, i) {
      return s + i.quantity;
    }, 0);

    return cart;
  }

  /* ============================================================
     DOM: HIDE ADDON ROWS
  ============================================================ */
  function hideAddonRows(cart) {
    var map = buildAddonMap(cart);
    map.addonKeys.forEach(function (key) {
      var row = document.querySelector('[data-key="' + key + '"]');
      if (row) {
        row.setAttribute("data-fc-addon", "1");
        row.style.setProperty("display", "none", "important");
      }
    });
  }

  var _hideTimer;
  function scheduleHide(delay) {
    clearTimeout(_hideTimer);
    _hideTimer = setTimeout(function () {
      getCart()
        .then(hideAddonRows)
        .catch(function () {});
    }, delay || 300);
  }

  /* ============================================================
     ITEM REMOVAL INTERCEPT
  ============================================================ */
  document.addEventListener(
    "click",
    function (e) {
      var removeBtn = e.target.closest(".cart-items__remove");
      if (!removeBtn) return;

      var row = removeBtn.closest("[data-key]");
      if (!row) return;

      var itemKey = row.getAttribute("data-key");
      if (!itemKey) return;

      getCart().then(function (cart) {
        var parentItem = cart.items.find(function (i) {
          return i.key === itemKey;
        });
        if (!parentItem) return;

        // Usamos o parent exato do item removido
        var pk = (parentItem.properties || {})["_fc_parent"];
        if (!pk) return;

        var map = buildAddonMap(cart);
        var addonKeysForProduct = map.addonRowKeys[pk] || [];

        if (!addonKeysForProduct.length) return;

        var toZero = {};
        addonKeysForProduct.forEach(function (k) {
          toZero[k] = 0;
        });

        _origFetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ updates: toZero }),
        });
      });
    },
    true,
  );

  /* ============================================================
     MUTATION OBSERVER & BOOTSTRAP
  ============================================================ */
  var _observer;
  function startObserver() {
    if (_observer) return;
    var debounce;
    _observer = new MutationObserver(function (mutations) {
      var hasNewRows = mutations.some(function (m) {
        return Array.from(m.addedNodes).some(function (n) {
          return (
            n.nodeType === 1 &&
            (n.matches(".cart-items__table-row") ||
              (n.querySelector && n.querySelector(".cart-items__table-row")))
          );
        });
      });
      if (!hasNewRows) return;
      clearTimeout(debounce);
      debounce = setTimeout(function () {
        scheduleHide(100);
      }, 50);
    });
    _observer.observe(document.body, { childList: true, subtree: true });
  }

  document.addEventListener("cart:refresh", function () {
    scheduleHide(400);
  });
  document.addEventListener("cart:updated", function () {
    scheduleHide(400);
  });

  startObserver();
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      scheduleHide(500);
    });
  } else {
    scheduleHide(500);
  }
})();
